export default "__VITE_ASSET__BYuwQ4XQ__"